
// ユーザーエージェント確認
require('./caracol2/util/check_user_agent.js');


/********************************
* DOM読み込み完了
*/
$( function(){
    'use strict';

    // 画像の遅延読み込み
    $('img.js-lazy').lazyload({effect:'fadeIn'});

    // 画像ポップアップ
     $('a.js-magnific').magnificPopup({
        type: 'image'
     });

    // サイドバーの位置固定
    $.SygFixScroll( '.js-sticky', {
        parent: '.js-sticky-parent'
    } );

    // メニュー制御
    require('./menu.js');

    // タブ制御
    var CaracolTab = require('./caracol2/navigation/tabs.js');
    new CaracolTab('.js-ccltab');

    // スクロール位置と方向によって反応するクラス
    var CaracolScrollAmount = require('./caracol2/effect/scroll_amount.js')
    new CaracolScrollAmount('.js-scroll-amount');

    // ページスクロール
    var CaracolPageScroll = require('./caracol2/effect/pagescroll.js');
    new CaracolPageScroll('.js-pagescroll');

    // SNSボタン
    require('./caracol2/social/share_button.js').set_share_button('.js-sns-btn');;


});






/*****************
 ** WEBPACK FOOTER
 ** ./js/common.js
 ** module id = 1
 ** module chunks = 0
 **/